import { ISignature } from 'Modules/Communication/shared/models/Signature'
import { RootState } from 'shared/store/store'

export interface SystemState {
  emailSettings: {
    signature: {
      data: ISignature | null
      loading: string
      error: unknown
      processing: boolean
      processingError: unknown
    }
  }
}

export const getEmailSignature = (state: RootState) =>
  state.emailSettings.signature
